import React, { Component } from 'react';
import { Input, Modal, Button, Select, message } from 'antd';
import AjaxRequest from '../../common/AjaxRequest';
import Ueditor from '../../common/Ueditor/Ueditor';
import API_URL from '../../common/url';
import moment from 'moment'

const Option = Select.Option;

const initState = {
    visible: false,
    confirmLoading: false,
    saveLoading: false,
    replyId : '',
    mode : 'new',//new,[edit,reply],view
    dateFormat: 'YYYY-MM-DD',
    questionDate: null,
    askPerson: '',
    investigationSiteCode: '',
    investigationSiteName: '',
    classify: '',
    questionOverview: '',
    askDetail: '',
    replyDate: '',
    replyPerson: '',
    replyDetail: '',
    typeList:[],
    questionCategoryId:'',
    questionCategoryName:'',
    questionText:'',
    questionLogId: null,
    answerDate: null,
    answerText: null,
    answerPerson:'',
    answerLogId: null
}

class QACreateModal extends Component {
        state = {
            ...initState
        }
    
        show = (id, m) => {
            this.setState({
                visible: true,
            });
            this.getTypeInfo();
            if (id) {
                this.loadData(id);
                let answerDate = null;
                let answerPerson ='';
                if(m == "reply"){
                    answerDate = moment().format(this.state.dateFormat);
                    answerPerson = sessionStorage.userName;
                }
                this.setState({
                    isEdit: true,
                    replyId : id,
                    mode : m,
                    questionLogId : id,
                    answerDate,
                    answerPerson,
                    noOverview: false,
                });
            } else{
                const {dateFormat} = this.state;
                const askPerson = sessionStorage.userName;
                const {investigationSiteCode,investigationSiteName} = sessionStorage;
                const questionDate = moment().format(dateFormat);
                 this.setState({
                    mode : 'new',
                    questionDate,
                    askPerson,
                    investigationSiteCode,
                    investigationSiteName,
                    noOverview: true,
                 }) 
            }
        };
    
    
        hide = () => {
            this.setState({
                ...initState,
            });
        };
        
        getTypeInfo = () => {
            const options = {
                method: 'POST',
                url: `${API_URL.execute.listQuestionCategory}`,
                doneResult: ( data => {
                        this.setState({
                            typeList: data.datas,
                        });
                    }
                ),
            };
            AjaxRequest.sendRequest(options);
        }   

        loadData = id => {
            const options = {
                method: 'POST',
                url: `${API_URL.execute.queryQuestionById}?questionLogId=${id}`,
                doneResult: ( data => {
                        if(data.questionLog.answerLog){
                            const {answerDate,answerText,userCompellation,answerLogId} = data.questionLog.answerLog;
                            this.setState({
                                ...data.questionLog,
                                askPerson: data.questionLog.userCompellation,
                                questionDate: moment(data.questionLog.questionDate).format(this.state.dateFormat),
                                answerDate: moment(answerDate).format(this.state.dateFormat),
                                answerText,
                                answerPerson: userCompellation,
                                answerLogId
                            })
                        }else{
                            this.setState({
                                ...data.questionLog,
                                askPerson: data.questionLog.userCompellation,
                                questionDate:moment(data.questionLog.questionDate).format(this.state.dateFormat),
                            });
                        }
                    }
                ),
            };
            AjaxRequest.sendRequest(options);
        }
    
        // 提交表单
        handleSubmit = () => {
            const {mode,questionOverview,questionCategoryId, questionDate, questionLogId,answerDate,answerLogId} = this.state;
            const uContentDetail = (mode == 'edit' || mode == 'new') ? UE.getEditor('uContent').getContent() : '';
            const isAnswer = ((sessionStorage.curRole == "PM" || sessionStorage.curRole == "PA") && (mode == "reply" || mode == "editPM")) || (this.props.reply == true && mode == "view");
            const answerText = isAnswer ? UE.getEditor('answerContent').getContent() : '';
            this.setState({
                questionText: uContentDetail
            })
            if(mode == "new" || mode == "editPM" || mode =="edit"){
                if(!questionCategoryId){
                    Modal.error({"title":"请选择问题分类"})
                    return;
                }
                if(!questionOverview){
                    Modal.error({"title":"请输入问题概述"})
                    return;
                }
                if(!uContentDetail){
                    Modal.error({"title":"请输入问题详情"})
                    return;
                }
            }else if(mode == "editPM" || mode == "reply"){
                if(!UE.getEditor('answerContent').getContent()){
                    Modal.error({"title":"请输入回复详情"})
                    return;
                }
            }
            const editQuestion = () => {
                const options = {
                    method: 'POST',
                    url: `${API_URL.execute.modifyQuestion}`,
                    data:{
                        questionOverview: questionOverview,
                        questionCategoryId: questionCategoryId,
                        questionText: uContentDetail,
                        questionLogId
                    },
                    doneResult: ( data => {
                            message.success('编辑成功');
                            this.hide();
                            this.props.reload();
                        }
                    ),
                };
                AjaxRequest.sendRequest(options);
            }
            const editAnswer = () => {
                const options = {
                    method: 'POST',
                    url: `${API_URL.execute.modifyAnswer}`,
                    data:{
                        answerLogId,
                        answerText,
                    },
                    doneResult: () => {
                        message.success('编辑成功');
                        this.hide();
                        this.props.reload();
                    },
                };
                AjaxRequest.sendRequest(options);
            }
            const answerQuestion = () => {
                const options = {
                    method: 'POST',
                    url: `${API_URL.execute.answerQuestion}`,
                    data:{
                        answerDate: answerDate,
                        answerText,
                        questionLogId
                    },
                    doneResult: () => {
                        message.success('回复成功');
                        this.hide();
                        this.props.reload();
                    },
                };
                AjaxRequest.sendRequest(options);
            }
            
            if(mode == "new"){//CRC新建问题
                const options = {
                    method: 'POST',
                    url: `${API_URL.execute.createQuestion}`,
                    data:{
                        questionOverview: questionOverview,
                        questionCategoryId: questionCategoryId,
                        questionText: uContentDetail,
                        questionDate
                    },
                    doneResult: () => {
                        message.success('新建成功');
                        this.hide();
                        this.props.reload();
                    },
                };
                AjaxRequest.sendRequest(options);
            }else if(mode == "edit"){//crc编辑问题
                editQuestion();
            }else if(mode == "reply"){//pm回复问题
                this.setState({
                    answerText,
                })
                answerQuestion();
            }else if(mode == "editPM"){//pm修改问题和回复
                this.setState({
                    answerText,
                })
                editQuestion();
                editAnswer();
            }
        }

        handleControlChange = (e) => {
            if(e.target.value){
                this.setState({
                    questionOverview: e.target.value,
                    noOverview: false
                })
            }else{
                this.setState({
                    questionOverview: e.target.value,
                    noOverview: true
                })
            }
        }
        
        handleChange = questionCategoryId => {
            this.setState({ questionCategoryId });
        }
    
        handleBlur = questionCategoryId => {
            this.setState({ questionCategoryId });
        }

        uContentChange = (questionText) => {
            const {noOverview} = this.state;
            if(noOverview){
                this.setState({
                    questionText
                })
            }
        }

        render() {
            const {
                visible,
                confirmLoading,
                mode,
                questionOverview,
                saveLoading,
                answerText,
                answerDate,
                answerPerson,
                questionDate, askPerson, investigationSiteCode, investigationSiteName,questionCategoryName,questionText,questionCategoryId
            } = this.state;
            let title,footerDom,editfooterDom;
            console.log('render', visible, mode, answerText);
            editfooterDom = [
                <Button key="save" type="primary" size="large" loading={saveLoading} onClick={this.handleSubmit}>
                    保存
                </Button>,
                <Button key="back" size="large" onClick={this.hide}>取消</Button>,
            ];
            if(mode == "edit"){
                title = '修改问题'
                footerDom = editfooterDom;
            }else if(mode == "reply"){
                title = '回复问题'
                footerDom = editfooterDom;
            }else if(mode == "view"){
                title = '查看问题记录'
                footerDom = [
                    <Button key="back" size="large" onClick={this.hide}>关闭</Button>
                ];
            }else if(mode == "editPM"){
                title = '修改问题\\回复'
                footerDom = editfooterDom;
            }else{
                title = '新建问题';
                footerDom = editfooterDom;
            }
            
            const options = this.state.typeList.map(d => <Option key={d.questionCategoryId.toString()}>{d.questionCategoryName}</Option>);

            return (
                <div>
                    {
                        visible &&
                        <Modal
                            title={title}                
                            visible={visible}
                            onCancel={this.hide}
                            className="qa-modal"
                            wrapClassName="vertical-center-modal"
                            width="940px"
                            confirmLoading={confirmLoading}
                            footer={footerDom}
                        >
                            <div className="cont-cont"  style={{ marginTop: 10 }}>
                                <ul className="preview-list">
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">提问日期</label>
                                            <span className="ui-text">{questionDate}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">提问人员</label>
                                            <span className="ui-text">{askPerson}</span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">中心编号</label>
                                            <span className="ui-text">{investigationSiteCode}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">中心名称</label>
                                            <span className="ui-text">{investigationSiteName}</span>
                                        </div>
                                    </li>
                                    
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">*问题分类</label>
                                            <span className="ui-text">
                                                {
                                                    mode == "view" || mode == "reply"  ?
                                                        <span>{questionCategoryName}</span>
                                                    :
                                                    <Select
                                                        value={questionCategoryId && questionCategoryId.toString()}
                                                        onChange={this.handleChange}
                                                        onBlur={this.handleBlur}
                                                        allowClear={true}
                                                        style={{width:'130px'}}
                                                    >
                                                        {options}
                                                    </Select>
                                                }
                                                
                                            </span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">*问题概述</label>
                                            <span className="ui-text">
                                                {
                                                    mode == "view" || mode == "reply" ?
                                                    <span>{questionOverview}</span>
                                                    :
                                                    <Input
                                                        value={questionOverview}
                                                        onChange={this.handleControlChange}
                                                        style={{width:300}}
                                                    />
                                                }
                                            </span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item" style={{ width: '100%' }}>
                                            <label className="ui-label">*问题详情</label>
                                            {
                                                (mode == "view" || mode == "reply") ?
                                                    <span className="ui-text" style={{float: 'left', width:740}}>
                                                        <div className="dangerousHtml" dangerouslySetInnerHTML={{
                                                            __html: questionText
                                                        }}/>
                                                    </span>
                                                :
                                                    <span className="ui-text" style={{float: 'left', width:880, marginTop:10}}>
                                                        <Ueditor id="uContent" uContentChange={this.uContentChange} uContent={questionText} initialFrameHeight="180" initialFrameWidth="880" />
                                                    </span>
                                            }
                                        </div>
                                    </li>
                                </ul>
                                {
                                    ((sessionStorage.curRole == "PM" || sessionStorage.curRole == "PA") && (mode == "reply" || mode == "editPM")) || (this.props.reply == true && mode == "view") ?
                                    <div>
                                        <div style={{marginTop:"20px",marginBottom:"10px",backgroundColor:"#ccc",height:"1px"}}></div>
                                        <ul className="preview-list">
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">回复日期</label>
                                                    <span className="ui-text">{answerDate}</span>
                                                </div>
                                                <div className="item">
                                                    <label className="ui-label">回复人员</label>
                                                    <span className="ui-text">{answerPerson}</span>
                                                </div>
                                            </li>
                                            <li className="preview-item" style ={{display: (mode == "view") ? "block": "none",background:'none'}}>
                                                <div className="item" style={{ width: '100%' }}>                                    
                                                    <label className="ui-label">回复详情</label>
                                                    <span className="ui-text" style={{float: 'left', width:740}}>
                                                            <div className="dangerousHtml" dangerouslySetInnerHTML={{
                                                                __html: answerText
                                                            }}/>
                                                    </span>
                                                </div>
                                            </li>
                                            <li className="preview-item" style ={{display: (mode !== "view") ? "block": "none",background:'none'}}>
                                                <div className="item" style={{ width: '100%' }}>
                                                    <label className="ui-label">*回复详情</label>
                                                    <span className="ui-text" style={{float: 'left', width:880, marginTop:10}}>
                                                        <Ueditor id="answerContent" uContent={answerText} initialFrameHeight="180" initialFrameWidth="880" />
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </Modal>
                    }
                </div>
            );
        }
    }
    
    export default QACreateModal;
    


// WEBPACK FOOTER //
// ./src/components/execute/QACreateModal.js